<template>
  <LoadingModal v-if="loading"/>

  <div class="pageContent" v-else>
    <div class="detailBox">
      <div class="detailSection">
        <h2 class="is-2 is-title" v-if="meta.title">{{ meta.title }}</h2>
        <h2 class="is-2 is-title is-blank" v-else>Maturitní práce bez názvu</h2>
        <div class="level">
          <div class="level-left">
            <div class="field is-grouped">
              <div class="control">
                <div class="tags has-addons">
                  <span class="tag is-dark">maturitní předmět</span>
                  <span class="tag is-light" v-if="meta.field">{{ meta.field.title }}</span>
                  <span class="tag is-warning" v-else>neuveden</span>
                </div>
              </div>

              <div class="control">
                <div class="tags has-addons">
                  <span class="tag is-dark">stav práce</span>
                  <span class="tag is-success" v-if="meta.uploaded">nahrána</span>
                  <span class="tag is-warning" v-else>nenahrána</span>
                </div>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <button
                class="btn spaceless isTurquoise"
                @click="goToThesis(meta.url)"
                v-if="meta.uploaded"
              >
                <icon type="eye" size="16"/>Zobrazit maturitní práci
              </button>
              <button class="btn spaceless isTurquoise isTranslucent isDisabled" v-else>
                <icon type="eye" size="16"/>Zobrazit maturitní práci
              </button>
            </div>
          </div>
        </div>

        <!--
        <div class="level">
          <div class="level-left"></div>
          <div class="level-right">
            <div class="level-item">
              <label class="file-label">
              <input class="file-input" type="file" @change="fileChange($event)">
              <button class="btn spaceless isBlue">
                <icon type="file" size="16" />
                Vybrat soubor
              </button>
              </label>
            </div>
          </div>
        </div>

        -->
      </div>

      <hr>

      <div class="detailSection">
        <h2 class="is-2 is-title unweighted">Posudek vedoucího</h2>
        <div class="level">
          <div class="level-left">
            <div class="field is-grouped">
              <div class="control">
                <div class="tags has-addons">
                  <span class="tag is-dark">vedoucí práce</span>
                  <span
                    class="tag is-light"
                    v-if="meta.supervisor"
                  >{{ meta.parsed.names.supervisor }}</span>
                  <span class="tag is-warning" v-else>nepřiřazen</span>
                </div>
              </div>

              <div class="control">
                <div class="tags has-addons">
                  <span class="tag is-dark">stav posudku</span>
                  <span
                    class="tag is-success"
                    v-if="meta.supervisor && meta.supervisor.report"
                  >vyplněn</span>
                  <span class="tag is-warning" v-else>nevyplněn</span>
                </div>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <button
                class="btn spaceless isDefault"
                v-if="meta.supervisor && meta.supervisor.report"
                @click="goToReport('supervisor')"
              >
                <icon type="eye" size="16"/>Zobrazit posudek
              </button>
              <button class="btn spaceless isDefault isDisabled isTranslucent" v-else>
                <icon type="eye" size="16"/>Zobrazit posudek
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="detailSection">
        <h2 class="is-2 is-title unweighted">Posudek oponenta</h2>
        <div class="level">
          <div class="level-left">
            <div class="field is-grouped">
              <div class="control">
                <div class="tags has-addons">
                  <span class="tag is-dark">oponent práce</span>
                  <span class="tag is-light" v-if="meta.reader">{{ meta.parsed.names.reader }}</span>
                  <span class="tag is-warning" v-else>nepřiřazen</span>
                </div>
              </div>

              <div class="control">
                <div class="tags has-addons">
                  <span class="tag is-dark">stav posudku</span>
                  <span class="tag is-success" v-if="meta.reader && meta.reader.report">vyplněn</span>
                  <span class="tag is-warning" v-else>nevyplněn</span>
                </div>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <button
                class="btn spaceless isDefault"
                v-if="meta.reader && meta.reader.report"
                @click="goToReport('reader')"
              >
                <icon type="eye" size="16"/>Zobrazit posudek
              </button>
              <button class="btn spaceless isDefault isDisabled isTranslucent" v-else>
                <icon type="eye" size="16"/>Zobrazit posudek
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parseDate } from '../util';
import { fetchThesisData } from '../http';
import LoadingModal from '../components/LoadingModal';

export default {
  components: {
    LoadingModal
  },

  data() {
    return {
      loading: true,
      uploadVisible: false,
      meta: null
    };
  },

  methods: {
    prepReportView(author) {
      const metadata = {
        thesisAuthor: this.$store.getters.fullUserName.trim(),
        author: this.meta.parsed.names[author].trim(),
        className: this.meta.userInfo.class,
        field: this.meta.field.title || null,
        title: this.meta.title || null
      };

      this.$store.commit('saveReport', {
        report: this.meta[author].report,
        metadata,
        author
      });
    },

    goToThesis(url) {
      window.open(url, '_blank');
    },

    goToReport(author) {
      this.prepReportView(author);
      this.$router.push({ path: 'report', query: { author } });
    }
  },

  async created() {
    try {
      const {
        data: { data }
      } = await fetchThesisData();

      this.meta = data;
      this.meta.parsed = {
        uploadDate: await parseDate(data.uploadedAt),
        names: {}
      };

      if (data.supervisor) {
        this.meta.parsed.names.supervisor = `${data.supervisor.degree || ''} ${
          data.supervisor.firstName
        } ${data.supervisor.lastName}`;
      }

      if (data.reader) {
        this.meta.parsed.names.reader = `${data.reader.degree || ''} ${data.reader.firstName} ${
          data.reader.lastName
        }`;
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../styles/buttons.sass'

h2.is-blank
  opacity: .25

.detailBox
  background: white
  box-shadow: 0 2px 3px rgba(10,10,10, .1), 0 0 0 1px rgba(10,10,10, .1)
  padding: 3.25rem 2rem
  margin: 1.75rem 0

.detailSection
  padding: 1.5rem 0

  &:nth-last-child(2)
    border-bottom: 1px solid #f5f5f5

.unweighted
  font-weight: normal

hr
  margin: 1.5rem 0
  background-color: rgba(#E3E3E3, .5)

.file-input
  width: 0
  height: 0
</style>
